import { render, staticRenderFns } from "./propertyNoticeList.vue?vue&type=template&id=98cf4df2&scoped=true"
import script from "./propertyNoticeList.vue?vue&type=script&lang=js"
export * from "./propertyNoticeList.vue?vue&type=script&lang=js"
import style0 from "./propertyNoticeList.vue?vue&type=style&index=0&id=98cf4df2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cf4df2",
  null
  
)

export default component.exports